import React from "react";

import { useGetApplicationQuery, useGetPlanCostsQuery, useGetPlansQuery } from "EmployeeApplication/api";
import { LifeContextProvider } from "EmployeeCoverage/Components/Life/life.context";
import { LifeEnrollmentModals } from "EmployeeCoverage/Components/Life/life.modals";
import { LifeMultiplePlans } from "EmployeeCoverage/Components/Life/life.multiplePlans";
import { LifePlan, PlanCost } from "Utils/types";
import { BasicLoading } from "ZeroRuby";

import { LifeSinglePlan } from "./life.singlePlan";

type Data =
  | {
      isLoading: true;
      plans: any;
      planCosts: any;
    }
  | {
      isLoading: false;
      plans: Array<LifePlan>;
      planCosts: Array<PlanCost>;
    };

const useData = (): Data => {
  const { isLoading: isLoadingApplication, data: { employeePolicy: { id } = {} } = {} } = useGetApplicationQuery();
  const { isLoading: isLoadingPlans, data: { plans = [] } = {} } = useGetPlansQuery(
    {
      id,
      type: "life",
    },
    { skip: !id },
  );
  const { isLoading: isLoadingCosts, data: { planCosts } = {} } = useGetPlanCostsQuery(
    {
      id,
      type: "life",
    },
    { skip: plans.length === 0 },
  );

  return {
    isLoading: isLoadingApplication || isLoadingPlans || isLoadingCosts,
    plans,
    planCosts,
  } as Data;
};

/**
 * This component manages what to render as life plans and costs are loaded.
 */
const StateManager = () => {
  const { isLoading, plans = [], planCosts = [] } = useData();
  if (isLoading) {
    return <BasicLoading />;
  }
  if (plans.length === 1) {
    return <LifeSinglePlan plan={plans[0]} planCost={planCosts.find(({ planID }) => planID === plans[0].id)} />;
  }
  if (plans.length > 1) {
    return <LifeMultiplePlans plans={plans} planCosts={planCosts} />;
  }
  return null;
};

export const LifePage = () => (
  <LifeContextProvider>
    <StateManager />
    <LifeEnrollmentModals />
  </LifeContextProvider>
);
